/** @jsx jsx */
/** @jsxFrag */
import { jsx } from '@emotion/react';
import SectionIntroduction from 'components/SectionIntroduction';
import ProductImage from 'icons/ProductPremium';
import React from 'react';
import theme from 'theme';
import { Application } from 'types/Application';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ApplicationPremiumPageIntroductionProps extends React.HTMLAttributes<HTMLDivElement> {
  application: Application;
}

const ApplicationPremiumPageIntroduction = React.forwardRef<HTMLDivElement, ApplicationPremiumPageIntroductionProps>(
  ({ application }, ref) => {
    return (
      <SectionIntroduction ref={ref}>
        <div
          css={{
            '& > img': { width: '100%' },
            '@media (min-width: 425px)': { maxWidth: 220 },
            '@media (min-width: 600px)': { maxWidth: 300, padding: theme.spacing(8, 0, 3, 0) },
            '@media (min-width: 960px)': { maxWidth: 450, padding: theme.spacing(3, 0) },
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 200,
          }}
        >
          <img src={application.logo} alt={application.title} />
        </div>
        <ProductImage
          css={{
            '@media(min-width: 600px)': { display: 'block', height: 400, top: -70 },
            '@media(min-width: 960px)': {
              right: -90,
              top: -90,
            },
            '@media(min-width: 1180px)': {
              height: 400,
              transform: 'scale(1.1)',
              width: 800,
            },
            bottom: 0,
            display: 'none',
            position: 'absolute',
            right: 0,
            width: '60%',
            zIndex: -1,
          }}
        />
      </SectionIntroduction>
    );
  },
);

export default ApplicationPremiumPageIntroduction;
